import {
  CustomAnswer,
  CustomQuestion,
} from "../redux/features/event/event.types";

export type CustomAnswerValues = Record<string, string | string[] | undefined>;
export type CustomAnswerErrors = Record<string, string>;

export const isCustomQuestionAnswered = (
  question: CustomQuestion,
  answer: string | string[] | undefined,
) => {
  if (question.type === "options" && question.optionType === "multiple") {
    return Array.isArray(answer) && answer.length > 0;
  }

  return typeof answer === "string" && answer.trim().length > 0;
};

export const getCustomAnswerErrors = (
  questions: CustomQuestion[],
  answers: CustomAnswerValues,
): CustomAnswerErrors => {
  return questions.reduce<CustomAnswerErrors>((acc, question) => {
    if (
      question.required &&
      !isCustomQuestionAnswered(question, answers[question._id])
    ) {
      acc[question._id] = "This question is required";
    }

    return acc;
  }, {});
};

export const buildCustomAnswers = (
  questions: CustomQuestion[],
  answers: CustomAnswerValues,
): CustomAnswer[] => {
  return questions
    .filter((question) =>
      isCustomQuestionAnswered(question, answers[question._id]),
    )
    .map((question) => {
      const answer = answers[question._id];

      return {
        questionId: question._id,
        answer: Array.isArray(answer) ? answer : `${answer ?? ""}`.trim(),
      };
    });
};
